import { memo } from 'react'


const GeoDemoInsights = memo(() => {

    return(
        <div className="mt-5">
            <h1>Campaign / media-buying / Insights / Geo Demo Insights</h1>
        </div>
    )

})


export default GeoDemoInsights